import Shape from '@enums/Shape';
import Size from '@enums/Size';

const NumberBadgeSize = Object.freeze({
  [Shape.CIRCLE]: {
    [Size.XX_SMALL]: {
      borderRadius: '0.7rem',
      fontSize: '0.7rem',
      fontWeight: 500,
      height: '1.15rem',
      lineHeight: '1.15rem',
      width: '1.15rem',
    },
    [Size.X_SMALL]: {
      borderRadius: '0.7rem',
      fontSize: '0.7rem',
      fontWeight: 500,
      height: '1.15rem',
      lineHeight: '1.15rem',
      width: '1.15rem',
    },
    [Size.SMALL]: {
      borderRadius: '2px',
      fontSize: '0.75rem',
      fontWeight: 500,
      height: '1.2rem',
      width: '1.2rem',
      lineHeight: '1.2rem',
    },
    [Size.MEDIUM]: {
      borderRadius: '0.825rem',
      fontSize: '0.825rem',
      fontWeight: 500,
      height: '1.5rem',
      lineHeight: '1.5rem',
      width: '1.5rem',
    },
    [Size.LARGE]: {
      borderRadius: '0.925rem',
      fontSize: '0.925rem',
      fontWeight: 500,
      height: '1.75rem',
      lineHeight: '1.75rem',
      width: '1.75rem',
    },
  },
  [Shape.SQUARE]: {
    [Size.XX_SMALL]: {
      borderRadius: '2px',
      fontSize: '0.7rem',
      fontWeight: 500,
      height: '0.9rem',
      lineHeight: '0.9rem',
      ml: 0.5,
      pl: '4px',
      pr: '4px',
    },
    [Size.X_SMALL]: {
      borderRadius: '2px',
      fontSize: '0.7rem',
      fontWeight: 700,
      height: '0.95rem',
      lineHeight: '0.95rem',
      ml: 0.5,
      pl: '6px',
      pr: '6px',
    },
    [Size.SMALL]: {
      borderRadius: '2px',
      fontSize: '0.75rem',
      fontWeight: 500,
      height: '1.2rem',
      width: '1.2rem',
      lineHeight: '1.2rem',
    },
    [Size.MEDIUM]: {
      borderRadius: '2px',
      fontSize: '0.825rem',
      fontWeight: 500,
      height: '1.5rem',
      lineHeight: '1.5rem',
      width: '1.5rem',
    },
    [Size.LARGE]: {
      borderRadius: '2px',
      fontSize: '0.925rem',
      fontWeight: 500,
      height: '1.75rem',
      lineHeight: '1.75rem',
      width: '1.75rem',
    },
  },
});

export default NumberBadgeSize;
